// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__4jPop","ranges":"BmiRanges_ranges__qC6E3"};